import authApi2 from '@/services/auth/api2';
import companyApi2 from '@/services/company/api2';
import constractApi2 from '@/services/contract/api2';
import dictApi2 from '@/services/dictionary/api2';
import financialApi from '@/services/financial/api';
import financialApi2 from '@/services/financial/api2';
import materialflowApi2 from '@/services/materialflow/api2';
import menuApi2 from '@/services/menu/api2';
import messageApi2 from '@/services/message/api2';
import projectApi2 from '@/services/project/api2';
import roleApi2 from '@/services/role/api2';
import systemApi2 from '@/services/system/api2';
import userApi2 from '@/services/user/api2';

const proxy = process.env.API_PROXY || '/api'; // api

const endpoints = {
  // login: '/admin/login',
  // 可以继续添加更多的 API 路径
  // ...companyApi,
  // ...userApi,
  // ...authApi,
  // ...roleApi,
  // ...systemApi,
  // ...projectApi,
  // ...dictApi,
  // ...menuApi,
  // ...materialflowApi,
  // ...financialApi,
  // ...messageApi,
};

const endpoints_v2 = {
  login: '/api/login',
  ...financialApi2,
  ...roleApi2,
  ...messageApi2,
  ...menuApi2,
  ...systemApi2,
  ...companyApi2,
  ...constractApi2,
  ...dictApi2,
  ...userApi2,
  ...projectApi2,
  ...materialflowApi2,
  ...authApi2,
};

export const API = Object.fromEntries(Object.entries(endpoints).map(([key, endpoint]) => [key, `${proxy}${endpoint}`]));
// console.log(API);
export const API_v2 = Object.fromEntries(
  Object.entries(endpoints_v2).map(([key, endpoint]) => {
    return [key, `${endpoint}`];
  }),
);
